function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var ToggledFeatureKey;
(function (ToggledFeatureKey) {
  ToggledFeatureKey["GROUP_STATS"] = "GROUP_STATS";
  ToggledFeatureKey["GROUP_STATS_VALIDATE_ONLY"] = "GROUP_STATS_VALIDATE_ONLY";
  ToggledFeatureKey["ANALYTICS_DEBUG"] = "ANALYTICS_DEBUG";
  ToggledFeatureKey["FREEZE_RANDOMNESS"] = "FREEZE_RANDOMNESS";
  ToggledFeatureKey["DESIGN_EXPERIMENTS"] = "DESIGN_EXPERIMENTS";
  ToggledFeatureKey["GRAPHQL_DISABLE_APQ"] = "GRAPHQL_DISABLE_APQ";
  ToggledFeatureKey["AUTOCOMPLETE_QUERY_FUZZY"] = "AUTOCOMPLETE_QUERY_FUZZY";
  ToggledFeatureKey["AUTOCOMPLETE_QUERY_WILDCARD"] = "AUTOCOMPLETE_QUERY_WILDCARD";
  ToggledFeatureKey["AUTOCOMPLETE_QUERY_AUTOCOMPLETE"] = "AUTOCOMPLETE_QUERY_AUTOCOMPLETE";
  ToggledFeatureKey["AUTOCOMPLETE_QUERY_PREFIX"] = "AUTOCOMPLETE_QUERY_PREFIX";
  ToggledFeatureKey["AUTOCOMPLETE_QUERY_PHRASE_PREFIX"] = "AUTOCOMPLETE_QUERY_PHRASE_PREFIX";
  ToggledFeatureKey["AUTOCOMPLETE_QUERY_SAYT"] = "AUTOCOMPLETE_QUERY_SAYT";
  ToggledFeatureKey["ENABLE_CORS"] = "ENABLE_CORS";
  ToggledFeatureKey["USE_UAT"] = "USE_UAT";
  ToggledFeatureKey["ENABLE_NEW_HEADER"] = "ENABLE_NEW_HEADER";
  ToggledFeatureKey["DARK_MODE"] = "DARK_MODE";
  ToggledFeatureKey["AUTO_DARK_MODE"] = "AUTO_DARK_MODE";
  ToggledFeatureKey["ADBRIDG"] = "ADBRIDG";
  ToggledFeatureKey["FOLLOWED_PROPERTIES"] = "FOLLOWED_PROPERTIES";
  ToggledFeatureKey["PRICE_GUIDE"] = "PRICE_GUIDE";
  ToggledFeatureKey["BUILD_TO_RENT"] = "BUILD_TO_RENT";
  ToggledFeatureKey["PRICE_ESTIMATES"] = "PRICE_ESTIMATES";
  ToggledFeatureKey["CLIENT_RENDER_LISTING_DESCRIPTION"] = "CLIENT_RENDER_LISTING_DESCRIPTION";
  ToggledFeatureKey["LISTING_ENQUIRY_FORM_FIELDS_CHANGES"] = "LISTING_ENQUIRY_FORM_FIELDS_CHANGES";
  ToggledFeatureKey["NEW_LISTING_VIEWS_BAR"] = "NEW_LISTING_VIEWS_BAR";
  ToggledFeatureKey["STRICT_NEW_LISTINGS"] = "STRICT_NEW_LISTINGS";
  ToggledFeatureKey["PEPPERMONEY_CTA"] = "PEPPERMONEY_CTA";
})(ToggledFeatureKey || (ToggledFeatureKey = {}));
var toggledFeatureDefs = {
  GROUP_STATS: {
    description: 'Whether or not sending to Group Stats is enabled',
    deprecated: true
  },
  GROUP_STATS_VALIDATE_ONLY: {
    description: 'When enabled, will force validation mode for group stats, and not actually send events'
  },
  ANALYTICS_DEBUG: {
    description: 'Causes the analytics event system to log debug messages to the console'
  },
  FREEZE_RANDOMNESS: {
    description: 'Force features based on randomness to return the same result every time'
  },
  DESIGN_EXPERIMENTS: {
    description: 'Enable experimental design changes'
  },
  GRAPHQL_DISABLE_APQ: {
    description: 'Disable the Automatic Persisted Queries feature of the Apollo client (for testing)'
  },
  AUTOCOMPLETE_QUERY_FUZZY: {
    description: 'Use the "fuzzy" algorithm for matching autocomplete entries'
  },
  AUTOCOMPLETE_QUERY_WILDCARD: {
    description: 'Use the "wildcard" algorithm for matching autocomplete entries'
  },
  AUTOCOMPLETE_QUERY_AUTOCOMPLETE: {
    description: 'Use the "wildcard" algorithm on the new "autocomplete" subfield for matching autocomplete entries'
  },
  AUTOCOMPLETE_QUERY_PREFIX: {
    description: 'Use the "prefix" algorithm for matching autocomplete entries'
  },
  AUTOCOMPLETE_QUERY_PHRASE_PREFIX: {
    description: 'Use the "match_phrase_prefix" algorithm for matching autocomplete entries'
  },
  AUTOCOMPLETE_QUERY_SAYT: {
    description: 'Use the "search_as_you_type" field type with "phrase_prefix" algorithm for matching autocomplete entries'
  },
  ENABLE_CORS: {
    description: 'Allows reflection of Access-Control-Allow-Origin on this domain for this browser'
  },
  USE_UAT: {
    description: 'When ENABLE_NEW_ACCOUNTS is enabled, use UAT services instead of staging'
  },
  ENABLE_NEW_HEADER: {
    description: 'Use the new header component',
    deprecated: true
  },
  DARK_MODE: {
    description: 'Force dark mode on or off'
  },
  AUTO_DARK_MODE: {
    description: "Use your system's dark mode settings. (Overrides DARK_MODE if enabled)"
  },
  ADBRIDG: {
    description: 'Use AdBridg instead of Titan on pages with it configured',
    deprecated: true
  },
  FOLLOWED_PROPERTIES: {
    description: 'Enable new Followed Properties feature',
    deprecated: true
  },
  PRICE_GUIDE: {
    description: 'Show Auction Price Guides on listings and search cards where provided'
  },
  BUILD_TO_RENT: {
    description: 'Enable build-to-rent components on the site'
  },
  PRICE_ESTIMATES: {
    description: 'Enable price estimates on My Properties'
  },
  CLIENT_RENDER_LISTING_DESCRIPTION: {
    description: 'Client render listing description for SEO purposes'
  },
  LISTING_ENQUIRY_FORM_FIELDS_CHANGES: {
    description: 'Use A/B testing on listing enquiry form fields'
  },
  NEW_LISTING_VIEWS_BAR: {
    description: 'Use new listing views bar on listing pages'
  },
  STRICT_NEW_LISTINGS: {
    description: 'Use strict new listings search type for new listings, which only returns listings that have never been listed before'
  },
  PEPPERMONEY_CTA: {
    description: 'Enable the PepperMoney CTA on sale listing pages'
  }
};
var toggledFeatureEntries = Object.values(ToggledFeatureKey).map(key => [key, _objectSpread({
  name: key
}, toggledFeatureDefs[key])]);
var ToggledFeature = Object.fromEntries(toggledFeatureEntries);
export var getToggledFeaturesFromCookieValue = function getToggledFeaturesFromCookieValue(cookieValue) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return cookieValue ? cookieValue.split(',').reduce((result, feature) => {
    var enabled = feature[0] !== '-';
    return _objectSpread(_objectSpread({}, result), {}, {
      [enabled ? feature : feature.substr(1)]: enabled
    });
  }, defaults) : defaults;
};
export var buildToggledFeaturesCookie = toggledFeatures => Object.keys(toggledFeatures).filter(feature => toggledFeatures[feature] != null).map(feature => "".concat(toggledFeatures[feature] ? '' : '-').concat(feature)).join(',');
export default ToggledFeature;